import { useTranslation } from 'react-i18next';

export default function SatisfactionGuarantee() {
  const { t } = useTranslation();
  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-background to-card/30 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-emerald-500 rounded-full blur-3xl" />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center mx-auto mb-6">
            <i className="ri-shield-check-line text-white text-4xl sm:text-5xl" />
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-foreground">
            {t('guarantee.title')} <span className="text-gradient">{t('guarantee.title2')}</span>
          </h2>
          <p className="text-lg sm:text-xl text-muted-foreground mb-8 sm:mb-10 max-w-2xl mx-auto" dangerouslySetInnerHTML={{ __html: t('guarantee.desc') }} />
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
            {[
              { icon: 'ri-money-cny-circle-line', titleKey: 'guarantee.g1_title', descKey: 'guarantee.g1_desc' },
              { icon: 'ri-calendar-check-line', titleKey: 'guarantee.g2_title', descKey: 'guarantee.g2_desc' },
              { icon: 'ri-customer-service-2-line', titleKey: 'guarantee.g3_title', descKey: 'guarantee.g3_desc' },
            ].map(({ icon, titleKey, descKey }) => (
              <div key={titleKey} className="bg-card/60 backdrop-blur-sm border border-border/50 rounded-2xl p-6 hover:border-emerald-500/50 transition-all">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-500/20 to-teal-500/20 flex items-center justify-center mx-auto mb-4">
                  <i className={`${icon} text-emerald-400 text-2xl`} />
                </div>
                <h3 className="font-bold text-foreground mb-2">{t(titleKey)}</h3>
                <p className="text-sm text-muted-foreground">{t(descKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
